// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomEnvelope = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '25',
      height: '24',
      viewBox: '0 0 25 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.61179 7.68206C1.28027 10.7641 1.29447 14.3185 1.75624 17.3887C1.88059 18.2136 2.27877 18.9727 2.88674 19.544C3.49472 20.1152 4.27715 20.4654 5.10821 20.5382L6.89609 20.6921C10.6258 21.0165 14.3744 21.0165 18.1041 20.6921L19.8919 20.5382C20.723 20.4654 21.5054 20.1152 22.1134 19.544C22.7214 18.9727 23.1196 18.2136 23.2439 17.3887C23.7057 14.3185 23.7199 10.7641 23.3884 7.68206C23.3456 7.32457 23.2975 6.96774 23.2439 6.61171C23.1196 5.78678 22.7214 5.02765 22.1134 4.4564C21.5054 3.88515 20.723 3.53498 19.8919 3.4622L18.1041 3.30828C14.3755 2.98448 10.6259 2.98448 6.89727 3.30828L5.1094 3.4622C4.27813 3.53473 3.49542 3.88479 2.88721 4.45606C2.27899 5.02733 1.88064 5.7866 1.75624 6.61171C1.70257 6.96849 1.65442 7.32528 1.61179 7.68206ZM7.05001 5.07721C10.6761 4.76113 14.3228 4.76113 17.9489 5.07721L19.7368 5.23232C20.1709 5.27021 20.5796 5.45301 20.8973 5.75131C21.2149 6.04961 21.423 6.44607 21.488 6.87693L21.5283 7.15281L14.9439 10.8114C14.1963 11.2268 13.3553 11.4447 12.5001 11.4447C11.6449 11.4447 10.8038 11.2268 10.0562 10.8114L3.47189 7.15281L3.51215 6.87693C3.57714 6.44625 3.78503 6.04993 4.10242 5.75165C4.41981 5.45338 4.82826 5.27047 5.26214 5.23232L7.05001 5.07721ZM21.7449 9.06382C21.9761 11.7511 21.8899 14.4563 21.488 17.1235C21.423 17.5541 21.2151 17.9505 20.8977 18.2487C20.5803 18.547 20.1719 18.7299 19.738 18.7681L17.9501 18.9232C14.3236 19.2393 10.6765 19.2393 7.05001 18.9232L5.26214 18.7681C4.82826 18.7299 4.41981 18.547 4.10242 18.2487C3.78503 17.9505 3.57714 17.5541 3.51215 17.1235C3.10985 14.4564 3.02322 11.7512 3.25403 9.06382L9.1931 12.3637C10.2045 12.9256 11.3425 13.2205 12.4995 13.2205C13.6565 13.2205 14.7944 12.9256 15.8059 12.3637L21.7449 9.06382Z',
      fill: 'black',
    }),
  );

export { IconCustomEnvelope };
